import React from 'react';

import style from './style.module.scss';

interface IProps {
  user?: { fullName: string; email: string };
}

const UserModalHead: React.FC<IProps> = ({ user }) => {
  return (
    <div className={style.userModalHead}>
      <div>{user?.fullName}</div>
      <p>{user?.email}</p>
    </div>
  );
};

export default UserModalHead;
